import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href,
  ...props
}: ButtonProps) {
  const baseClass = `bg-yellow-400 hover:bg-yellow-300 text-green-900 font-black py-4 px-8 rounded-xl shadow-lg shadow-yellow-400/30 transition-colors duration-300 w-full md:w-auto text-lg md:text-xl flex items-center justify-center gap-2 ${className}`;
  if (href) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} target="_blank" rel="noopener noreferrer" className={baseClass} data-id="element-44">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={baseClass} {...props} data-id="element-45">
      {children}
    </motion.button>;
}